import React, { Component } from 'react';
import './iamExActions.css';
import {Auth} from 'aws-amplify';
import AWS from 'aws-sdk';
import IamExUserPermissions from './iamExAcUserPermissions/iamExAcUserPermissions.js';
import IamExTitleBar from './iamExAcTitleBar/iamExAcTitleBar.js';

class IamExplorer extends Component {

  state = {
    iamAuditUsers: [],
    headers: []
  };

    S3;

    componentDidMount() {

      setTimeout(() => {
        Auth.currentCredentials()
        .then(credentials => {
          this.S3 = new AWS.S3({credentials: Auth.essentialCredentials(credentials)});
          return this.downloadIamAudit();
        })
        .catch(err => {
          console.log(err);
        });
      }, 0);

    };

    downloadIamAudit = () => {

      return this.S3.getObject({Bucket: 'weaveability-basis-utilities-storage', Key: 'iamAudit/iamAudit.json'}).promise()
      .then(res => {
        this.setState({iamAuditUsers: JSON.parse(res.Body.toString()).Users});
      });

    };

    render() {

      return (
        <div className="IamExplorerPage">
          <IamExTitleBar iamAuditUsers={this.state.iamAuditUsers} manageHeaders={this.manageHeaders}/>
          <IamExUserPermissions iamAuditUsers={this.state.iamAuditUsers} headers={this.state.headers}/>
        </div>
      );

    };

    manageHeaders = (header, action) => {
      const currentHeaders = this.state.headers;
      if (action === 'add') {
        currentHeaders.push(header);
      } else {

      };
      this.setState({headers: currentHeaders});
    };

};

export default IamExplorer;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExActions/iamExActions.js